import { Menu, MenuList } from '@chakra-ui/react'
import { DARK_MENU_LIST_PROPS } from 'constants/dark-tokens'
import { Token, Width } from 'types/chakra'
import DropdownButton from 'components/Dropdown/DropdownButton'
import DropdownSelection from 'components/Dropdown/DropdownSelection'
import { getValidArray } from 'utils/common'

export interface IPageSizeDropdownProps {
  options: number[]
  onChange: (pageSize: number) => void
  item: number
  width?: Token<Width | number, 'sizes'>
  /** Opt-in dark-surface styling (default light). */
  dark?: boolean
}

const PageSizeDropdown = (props: IPageSizeDropdownProps) => {
  const { options, onChange, item, width, dark } = props
  return (
    <Menu computePositionOnMount>
      {({ isOpen }) => (
        <>
          <DropdownButton placeHolder={`${item} rows`} isOpen={isOpen} width={width} minWidth={width} dark={dark} />
          <MenuList
            zIndex="1001"
            maxWidth={width}
            minWidth={width}
            {...(dark ? DARK_MENU_LIST_PROPS : {})}
          >
            {getValidArray(options).map((option: number, index: number) => (
              <DropdownSelection
                key={`option-${index}`}
                onClick={() => onChange(option)}
                label={`${option} rows`}
                isSelected={option === item}
                width={width}
                dark={dark}
              />
            ))}
          </MenuList>
        </>
      )}
    </Menu>
  )
}

export default PageSizeDropdown
